/**
 *  ex: <span>{{ '100000' | amount }}</span>
 */
export default {
	amount: function (value) {
		const num = value.length
		let int = num > 4 ? value.substr(0, num - 4) : '0'
		let dec = num > 4 ? value.substr(num - 4) : padStart(value, 4, '0')
		dec = dec.replace(/0{1,2}$/, '')

		return int + "." + dec
	}
}

function padStart(str, targetLength, padString) {
	targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
	padString = String(typeof padString !== 'undefined' ? padString : ' ');
	if (str.length > targetLength) {
		return String(this);
	} else {
		targetLength = targetLength - str.length;
		if (targetLength > padString.length) {
			padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
		}
		return padString.slice(0, targetLength) + String(str);
	}
}
